import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

export const GradeReasonModal = ({ isOpen, defaultReason, onSubmit, onCancel }) => {
    const [reason, set_reason] = useState('');

    const styles = {
        buttonMarginRight: { marginRight: '10px' },
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
    };

    const onSaveClick = () => {
        onSubmit && onSubmit(reason.trim());
    };

    const onCancelClick = () => {
        onCancel && onCancel(reason);
    };

    if (!isOpen) {
        return;
    }
    return (
        <Dialog
            maxWidth='md'
            open={isOpen}
            onClose={onCancelClick}
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex='-1'
                    role='dialog'
                    style={{ width: '700px', overflow: 'unset' }}
                >
                    <div
                        className='page-header'
                        role='banner'
                    >
                        <h1 className='page-header-single-h1'>Grade Change Reason</h1>
                    </div>
                    <div
                        className='main-content no-search'
                        style={{ padding: '10px', width: '100%' }}
                    >
                        <input
                            id='gradeReason'
                            maxLength={200}
                            type='text'
                            value={reason ?? defaultReason}
                            onChange={(e) => set_reason(e.target.value)}
                            placeholder='Please enter a reason for the grade change'
                        />
                    </div>
                    <div
                        className='button-footer'
                        style={styles.buttonContainer}
                    >
                        <button
                            type='button'
                            className='button primary'
                            onClick={onSaveClick}
                            disabled={!(reason ?? '').trim()}
                        >
                            Submit
                        </button>
                        &nbsp;
                        <button
                            type='button'
                            onClick={onCancelClick}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};
